import { THEME_CONFIG_KEY } from '../helpers/localStorageKeys.const';
import { getOrganizationCode } from './organizationSettings';
import defaultTheme from './themes/themedefault';

const mergeColors = (dynamicTheme: { palette?: typeof defaultTheme.palette }) => {
  const colors: typeof defaultTheme.palette = {} as typeof defaultTheme.palette;
  const dynamicPalette = dynamicTheme.palette || ({} as typeof defaultTheme.palette);

  (Object.keys(defaultTheme.palette) as Array<keyof typeof defaultTheme.palette>).forEach(colorName => {
    const dynamicColors = dynamicPalette[colorName] || [];
    const defaultColors = defaultTheme.palette[colorName] || [];
    colors[colorName] = [...dynamicColors, ...defaultColors.slice(dynamicColors.length)];
  });

  return colors;
};

interface ThemeAssets {
  [key: string]: any;
}

interface ThemePalette {
  [colorName: string]: string[];
}

interface OrganizationTheme {
  assets: ThemeAssets;
  palette: ThemePalette;
  organizationCode?: string;
  [key: string]: any;
}

export function getOrganizationTheme(theme?: Partial<OrganizationTheme>): OrganizationTheme {
  const themeConfig = localStorage.getItem(THEME_CONFIG_KEY);
  let dynamicTheme: Partial<OrganizationTheme> =
    theme || (themeConfig ? JSON.parse(themeConfig) : { assets: {}, palette: {} });

  dynamicTheme = {
    ...defaultTheme,
    ...dynamicTheme,
    organizationCode: getOrganizationCode(),
    assets: {
      ...defaultTheme.assets,
      ...dynamicTheme.assets,
    },
    palette: {
      ...mergeColors(dynamicTheme as { palette: typeof defaultTheme.palette }),
    },
  };

  // Save theme in local storage only when fetched from API
  if (theme) {
    localStorage.setItem(THEME_CONFIG_KEY, JSON.stringify(dynamicTheme));
  }

  return dynamicTheme as OrganizationTheme;
}
